// BotsHub — the "Bots" segment of the merged People area (UX Phase 4).
// Bots used to live under Settings ▸ Bot profiles; they're people the admin
// manages too, so they now sit beside Players and Agents. This is a thin
// wrapper: the People segment bar + the existing self-contained bot roster.
import PeopleSegmentBar from '../components/PeopleSegmentBar';
import BotsListPanel from '../panels/people/BotsListPanel';

export default function BotsHub() {
  return (
    <div>
      <PeopleSegmentBar current="bots" />
      <div className="max-w-screen-2xl mx-auto px-2 sm:px-3 lg:px-6 py-3 lg:py-4">
        <BotsListPanel />
      </div>
    </div>
  );
}
